<template>
  <el-card class="month-salary-range">
    <div class="title">月薪区间分布</div>
    <div ref="statistics" class="data">
      <template v-for="(color, key) in colorObj" :key="key">
        <el-row class="wage-month-salary-range-item-box">
        <span>{{key}}</span>
        <el-progress :percentage="(statisticsDataObj[key] && statisticsDataObj[key].ratio) || 0" :stroke-width="20" :color="color" />
      </el-row>
      </template>
      
      
    </div>
  </el-card>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    statisticsData: Object
  },
  data() {
    return {
      myCharts: null,
      colorObj: {
        '15000以上': '#c280ff',
        '10000-15000': '#4e86fe',
        '8000-10000': '#39c2ba',
        '5000-8000': '#ffa936',
        '3000-5000': '#ec808d',
        '3000以下': '#95f204'
      }
    }
  },
  computed: {
    statisticsDataObj() {
      let data = this.statisticsData || [];
      let ret = {};
      data.forEach(d => {
        ret[d.name] = d;
      });
      return ret;
    }
  }
})
</script>

<style lang="scss" scoped>
.month-salary-range {
  width: 32%;
  .title {
    text-align: center;
    font-weight: bold;
    font-size: 19px;
    margin-bottom: 15px;
  }
  .data {
    .wage-month-salary-range-item-box {
      height: 40px;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      >span:first-child {
        width: 100px;
      }
      .el-progress {
        width: calc(100% - 100px);
      }
    }
  }
}


</style>

<style lang="scss">
.wage-month-salary-range-item-box {
  .el-progress {
    .el-progress-bar {
      .el-progress-bar__outer {
        border-radius: 0;
        .el-progress-bar__inner {
          border-radius: 0;
        }
      }
    }
    .el-progress__text {
      width: 65px;
    }
  }
}
</style>